import React, { useState, useEffect } from 'react';
import IssuersTemplateStyle from './IssuersTemplateStyle';
import Text from '../../atoms/Text/Text';
import HeaderText from '../../atoms/HeaderText/Text';
import Image from '../../atoms/Image/Img';
import Input from '../../atoms/Input/Input';
import exportIcon from '../../../assets/images/download-icon.svg';
import plusIcon from '../../../assets/images/plus-icon-white.svg';
import filterIcon from '../../../assets/images/filter-icon.svg';
import plus from '../../../assets/images/plus-icon.svg';
import IssuersTable from '../../organisms/IssuersTable/IssuersTable';
import nike from '../../../assets/images/nike.svg';
import Button from '../../atoms/Button/Button';
import { useDispatch, useSelector } from 'react-redux';
import { TypedDispatch, RootStore } from '../../../config/ConfigStore';
import { DashboardActions } from '../../../redux/actions/DashboardAction';
import { exportAll, exportClear } from '../../../redux/actions/ExportAction';
import FetchLoading from '../../molecules/FetchLoading/FetchLoading';
import { CSVLink } from "react-csv";
import dayjs from 'dayjs';
import { NavLink, useNavigate } from 'react-router-dom';
import { addDays, format } from 'date-fns';
import { DateRange, DayPicker } from 'react-day-picker';
import caret from '../../../assets/images/caret-filter-select.svg';
import CreateIssuerModal from '../../organisms/CreateIssuerModal/CreateIssuerModal';

const pastMonth = new Date();

const IssuersTemplate = () => {
  let timeOutId: any = null;
  const [toggleCreateIssuerModal, setToggleCreateIssuerModal] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [reloadPage, setReloadPage] = useState(false);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const dispatch: TypedDispatch = useDispatch();
  const state: any = useSelector((state: RootStore) => state);
  // const navigate = useNavigate();
  const [filterValues, setFilterValues] = useState<any>({});
  const [fields, setFields] = useState({
    dateRange: '',
    bankCode: '',
    status: ''
  });

  const onClickHandler = (value: boolean) => {
    if (selectedMenu !== false) {
      setSelectedMenu(false);
      return;
    }
    setSelectedMenu(value);
  }

  const onBlurHandler = () => {
    timeOutId = setTimeout(() => {
      setSelectedMenu(false);
    });
  }

  const onFocusHandler = () => {
    clearTimeout(timeOutId);
  }

  useEffect(() => {
    dispatch(exportAll(`/payroll/configuration/issuers?size=0&page=1`));
  }, [])

  useEffect(() => {
    dispatch(exportClear())
    generatePageContent();
    console.log(state);
  }, [size, page, reloadPage])

  const generatePageContent = async () => {
    setFetchLoading(true);
    await dispatch(DashboardActions(`/payroll/configuration/issuers?size=${size}&page=${page}&name=${search}`));
    setFetchLoading(false);
  }

  const renderFetchLoading = () => {
    if (fetchLoading) {
      return (
        <FetchLoading />
      )
    }
  }

  const changePage = (value: number) => {
    setPage(value);
  }

  const changeSize = (value: number) => {
    setSize(value);
  }

  const showCreateIssuerModal = () => {
    setToggleCreateIssuerModal(true);
  }

  const hideCreateIssuerModal = () => {
    setToggleCreateIssuerModal(false);
  }

  const renderCreateIssuerModal = () => {
    if (toggleCreateIssuerModal) {
      return (
        <CreateIssuerModal handleClose={hideCreateIssuerModal} reloadPage={refreshTable} />
      )
    }
  }

  const exportData = () => {
    return {
      fileData: () => {
        const getIssuerType = (type: number) => {
          if (type === 1) {
            return 'Commercial Bank'
          }
          else if (type === 2) {
            return 'Microfinance bank'
          }
          else {
            return 'Wallet'
          }
        }
        let issuers = state.exportReducer.results.data.map((issuer: Record<any, any>) => {
          return (
            {
              InstitutionName: issuer.name,
              BankCode: issuer.issuerCode,
              IssuerPhone: issuer.contactNumber,
              IssuerEmail: issuer.issuerEmail,
              BankType: getIssuerType(issuer.issuerType),
              DateCreated: dayjs(issuer.createdDate).format('MM/DD/YYYY'),
            }
          )
        })
        let data = [...issuers];
        return data
      },
      fileHeaders: () => {
        let headers = [
          { label: "Institution Name", key: "InstitutionName" },
          { label: "Issuer Code", key: "BankCode" },
          { label: "Issuer Email", key: "IssuerEmail" },
          { label: "Issuer Phone", key: "IssuerPhone" },
          { label: "Bank Type", key: "BankType" },
          { label: "Date Created", key: "DateCreated" },
        ];
        return headers;
      }
    }
  }

  const exportDataAll = () => {
    return {
      fileData: () => {
        const getIssuerType = (type: number) => {
          if (type === 1) {
            return 'Commercial Bank'
          }
          else if (type === 2) {
            return 'Microfinance bank'
          }
          else {
            return 'Wallet'
          }
        }
        let issuers = state.exportReducer.allResults.data.map((issuer: Record<any, any>) => {
          return (
            {
              InstitutionName: issuer.name,
              BankCode: issuer.issuerCode,
              IssuerPhone: issuer.contactNumber,
              IssuerEmail: issuer.issuerEmail,
              BankType: getIssuerType(issuer.issuerType),
              DateCreated: dayjs(issuer.createdDate).format('MM/DD/YYYY'),
            }
          )
        })
        let data = [...issuers];
        return data
      },
      fileHeaders: () => {
        let headers = [
          { label: "Institution Name", key: "InstitutionName" },
          { label: "Issuer Code", key: "BankCode" },
          { label: "Issuer Email", key: "IssuerEmail" },
          { label: "Issuer Phone", key: "IssuerPhone" },
          { label: "Bank Type", key: "BankType" },
          { label: "Date Created", key: "DateCreated" },
        ];
        return headers;
      }
    }
  }

  const refreshTable = () => {
    if (reloadPage) {
      return setReloadPage(false);
    }
    setReloadPage(true);
  }

  const defaultSelected: DateRange = {
    from: pastMonth,
    to: addDays(pastMonth, 4)
  };
  const [range, setRange] = useState<DateRange | any>(defaultSelected);

  let footer = <p>Please pick the first day.</p>;
  if (range !== undefined && range.from) {
    if (!range.to) {
      footer = <p>{format(range.from, 'PPP')}</p>;
    } else if (range.to) {
      footer = (
        <p>
          {format(range.from, 'PPP')}–{format(range.to, 'PPP')}
        </p>
      );
    }
  }

  const changeFilterValue = async (event: any, name: string, value: string) => {
    if (event.target.checked) {
      const filterValuesObj: any = Object.assign({}, filterValues);
      filterValuesObj[name] = value;
      await setFilterValues(filterValuesObj);
    }
    else {
      const filterValuesObj: any = Object.assign({}, filterValues);
      delete filterValuesObj[name]
      await setFilterValues(filterValuesObj);
    }
  }

  const inputChange = async (name: string, value: string) => {
    const fieldsValues: any = Object.assign({}, fields);
    fieldsValues[name] = value;
    await setFields(fieldsValues);
  };

  const fetchFilteredContent = async () => {
    setFetchLoading(true);
    await dispatch(DashboardActions(`/payroll/configuration/issuers?size=${size}&page=${page}${filterValues.status && fields.status !== '' ? `&status=${fields.status}` : ''}${filterValues.bankCode && fields.bankCode !== '' ? `&issuerCode=${fields.bankCode}` : ''}${filterValues.dateRange && range ? `&createdDateFrom=${dayjs(range.from).format("YYYY-MM-DD HH:mm:ss")}` : ''}${filterValues.dateRange && range ? `&createdDateTo=${dayjs(range.to).format("YYYY-MM-DD HH:mm:ss")}` : ''}`));
    setFetchLoading(false);
    setSelectedMenu(false);
  }

  return (
    <>
      {renderFetchLoading()}
      {renderCreateIssuerModal()}
      <IssuersTemplateStyle>
        <div className={`container-full issuers`}>
          <div className={`container-full issuers__desc`}>
            <HeaderText value="Payroll Configuration" />
          </div>
          <div className='container-full issuers__action'>
            <div className={`issuers__action__nav`}>
              <NavLink
                to="/payroll-config/issuers"
                className={({ isActive }) =>
                  isActive ? "--active-nav" : undefined
                }
              >
                <div className={`issuers__action__nav__item`}>
                  <Text value={`Issuers`} />
                </div>
              </NavLink>
              <NavLink
                to="/payroll-config/statutory-bodies"
                className={({ isActive }) =>
                  isActive ? "--active-nav" : undefined
                }
              >
                <div className={`issuers__action__nav__item`}>
                  <Text value={`Statutory Bodies`} />
                </div>
              </NavLink>
            </div>
            <div className={`issuers__action__search`}>
              <Input className={`input`} type="text" placeholder="Search issuers"
                onChange={(event) => setSearch(event.target.value)}
                onKeyPress={event => {
                  if (event.key === 'Enter' || event.which === 13 || event.keyCode === 13) {
                    generatePageContent();
                  }
                }}
              />
              <div className='btn-group'>
                {
                  (state.exportReducer.results.data.length > 0) ?
                    <CSVLink data={exportData().fileData()} headers={exportData().fileHeaders()} filename={"issuers.csv"}>
                      <button className='button --export'>
                        <Image image={exportIcon} />
                      </button>
                    </CSVLink> :
                    <CSVLink data={exportDataAll().fileData()} headers={exportDataAll().fileHeaders()} filename={"issuers.csv"}>
                      <button className='button --export'>
                        <Image image={exportIcon} />
                      </button>
                    </CSVLink>
                }
                <button className={`button --user ${state.authReducer.results.roles.includes('Administrator') ? '' : 'disabled'} }`} onClick={() => showCreateIssuerModal()}>
                  <Image image={plusIcon} />
                </button>
              </div>
            </div>
          </div>
          <div className={`container-full merchant__filter`}>
            <div className={`merchant__filter__item --filter`}>
              <div className={`--filter__box`}>
                <Image image={filterIcon} alt="filter-icon" />
              </div>
              <Text value='Filter' />
            </div>
            {/* <div className={`merchant__filter__item --active-filter`}>
                <Text value='No active filters' />
              </div> */}
            <div className={`merchant__filter__item --add-filter`} onBlur={() => onBlurHandler()} onFocus={() => onFocusHandler()}>
              <button className={`button --elipses`} onClick={() => onClickHandler(true)} aria-haspopup="true" aria-expanded={selectedMenu}>
                <Image image={plus} />
                <Text value='Add filter' />
              </button>
              {
                selectedMenu !== false && (
                  <button className='unset'>
                    <div className={`container-full more-info`}>
                      <div className={`container-full more-info__top`}>
                        <div className={`div-md-4 more-info__top__item`}>
                          <div className={`container-full more-info__top__item__desc`}>
                            <div className={`more-info__top__item__desc__checkbox`}>
                              <input
                                type="checkbox"
                                name="dateRange"
                                onChange={(event) => changeFilterValue(event, event.target.name, event.target.value)}
                                defaultChecked={(filterValues.dateRange) ? true : false}
                              />
                              <Image image={nike} />
                            </div>
                            <Text value='Date Range' />
                          </div>
                          <div className={`container-full more-info__top__item__input`}>
                            <Input type="text" className={`input ${(filterValues.dateRange === undefined) ? 'disabled' : null
                              }`}
                              placeholder="Select Date Range"
                              value={(range) ? `${dayjs(range.from).format("YYYY-MM-DD")} to ${dayjs(range.to).format("YYYY-MM-DD")}` : ''}
                              name="dateRange"
                              onChange={(evt) => inputChange(evt.target.name, evt.target.value)}
                              readOnly
                            />
                            {
                              (filterValues.dateRange) ?
                                <DayPicker
                                  mode="range"
                                  defaultMonth={pastMonth}
                                  selected={range}
                                  footer={footer}
                                  modifiersStyles={{
                                    selected: {
                                      background: 'blue',
                                      color: 'white',
                                      fontWeight: 'bold',
                                    },
                                  }}
                                  onSelect={setRange}
                                  style={{ position: "absolute", left: "0", marginTop: "40px", background: "white", boxSizing: "border-box", padding: "35px", boxShadow: "0px 15px 44px rgba(10, 18, 73, 0.15)" }}
                                  styles={{
                                    day: { boxSizing: "border-box", padding: '10px', borderRadius: "8px", fontFamily: "Mulish", },
                                    caption: { fontFamily: "Mulish" },
                                  }}
                                /> : null
                            }
                          </div>
                        </div>
                        <div className={`div-md-4 more-info__top__item`}>
                          <div className={`container-full more-info__top__item__desc`}>
                            <div className={`more-info__top__item__desc__checkbox`}>
                              <input
                                type="checkbox"
                                name="bankCode"
                                onChange={(event) => changeFilterValue(event, event.target.name, event.target.value)}
                                defaultChecked={(filterValues.bankCode) ? true : false}
                              />
                              <Image image={nike} />
                            </div>
                            <Text value='Bank Code' />
                          </div>
                          <div className={`container-full more-info__top__item__input`}>
                            <Input type="text"
                              className={`input ${(filterValues.bankCode === undefined) ? 'disabled' : null
                                }`}
                              placeholder="Enter Bank Code"
                              name="bankCode"
                              value={fields.bankCode}
                              onChange={(evt) => inputChange(evt.target.name, evt.target.value)}
                            />
                          </div>
                        </div>
                        <div className={`div-md-4 more-info__top__item`}>
                          <div className={`container-full more-info__top__item__desc`}>
                            <div className={`more-info__top__item__desc__checkbox`}>
                              <input
                                type="checkbox"
                                name="status"
                                onChange={(event) => changeFilterValue(event, event.target.name, event.target.value)}
                                defaultChecked={(filterValues.status) ? true : false}
                              />
                              <Image image={nike} />
                            </div>
                            <Text value='Status' />
                          </div>
                          <div className={`container-full more-info__top__item__input`}>
                            <div className='input'>
                              <select required
                                className={
                                  `${(filterValues.status === undefined) ? 'disabled' : null}`
                                }
                                name="status"
                                value={fields.status}
                                onChange={(evt) => inputChange(evt.target.name, evt.target.value)}
                              >
                                <option value="" hidden> Select Issuer Status </option>
                                <option value="1"> Active </option>
                                <option value="0"> Disabled </option>
                                <option value="2"> Pending </option>
                                <option value="3"> Pending update enabled </option>
                                <option value="4"> Pending update disabled </option>
                                <option value="5"> Rejected pending </option>
                              </select>
                              <Image image={caret} />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={`container-full more-info__bottom`}>
                        <Button value="Cancel" className='button --cancel' onClick={() => setSelectedMenu(false)} />
                        <Button value="Apply Filters" className={`button --apply`} onClick={() => fetchFilteredContent()} />
                      </div>
                    </div>
                  </button>
                )
              }
            </div>
          </div>
          <div className='container-full issuers__table'>
            {
              (state.dashboardReducer.results !== null) ?
                <IssuersTable data={state.dashboardReducer.results} pagination={size} setPagination={changeSize} changePage={changePage} page={page} reloadPage={refreshTable} /> : null
            }
          </div>
        </div>
      </IssuersTemplateStyle>
    </>
  );

};

export default IssuersTemplate;
